import request from '../util/request'

/**
 * 获取物流轨迹热力图
 */
export function getTrajectoryHeat () {
  return request({
    url: '/api/getTrajectoryHeat',
    method: 'GET'
  })
}

/**
 * 获取物流重量热力图
 */
export function getWeightHeat () {
  return request({
    url: '/api/getWeightHeat',
    method: 'GET'
  })
}
